import { useState } from 'react'
import { useIsomorphicLayoutEffect, useResponsive } from './'

export const useMobileProductCardTrigger = () => {
  const { breakpoints, isSmallScreen } = useResponsive()
  const [showMobileCard, setShowMobileCard] = useState(false)

  useIsomorphicLayoutEffect(() => {
    if ((breakpoints.max.SM || isSmallScreen) && !showMobileCard) {
      setShowMobileCard(true)
    } else if (breakpoints.min.SM && showMobileCard) {
      setShowMobileCard(false)
    }
  }, [breakpoints])

  return { showMobileCard }
}
